import { ReactElement } from 'react';
import { useAnalytics } from '@provider-directory/components/analytics/analytics-provider';

interface FooterSocialLinkProps {
  href: string;
  ariaLabel: string;
  analyticsText: string;
  icon: ReactElement;
}

export const FooterSocialLink: React.FC<FooterSocialLinkProps> = ({
  href,
  ariaLabel,
  analyticsText,
  icon,
}) => {
  const analytics = useAnalytics();
  return (
    <li className={'leading-[0]'}>
      <a
        href={href}
        aria-label={ariaLabel}
        className={'block'}
        onClick={() => {
          analytics.navigationClickEvent({
            navigationType: 'footer',
            clickText: analyticsText,
            linkType: 'link',
          });
        }}
      >
        <span
          className={'mf-icon mf-icon--small mf-icon--gray-dark'}
          data-analytics-click-text={analyticsText}
          data-analytics-link-type={'icon'}
        >
          {icon}
        </span>
      </a>
    </li>
  );
};
